// import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

// @Directive({
// 	selector: '[appColumnResizable]'
// })

// export class ColumnResizableDirective {
// 	constructor(
// 		private el: ElementRef,
// 		private renderer: Renderer2,
// 	) {}

// 	@HostListener('mousedown', ['$event']) onMouseDown(event: MouseEvent) {
// 		const mouseMoveSub = this.renderer.listen('document', 'mousemove', (e) => this.onMouseMove(e));
// 		this.renderer.listen('document', 'mouseup', () => {
// 			mouseMoveSub(); // Unsubscribe from mousemove on mouseup
// 		});
// 	}

// 	onMouseMove(event: MouseEvent) {
// 		const width = event.clientX - this.el.nativeElement.getBoundingClientRect().left;
// 		this.renderer.setStyle(this.el.nativeElement, 'width', `${width}px`);
// 	}
// }


import { Directive, ElementRef, HostListener, Renderer2, OnInit } from '@angular/core';

@Directive({
	selector: '[appColumnResizable]'
})
export class ColumnResizableDirective implements OnInit {

	constructor(
		private el: ElementRef,
		private renderer: Renderer2,
	) {}

	ngOnInit() {
		// Set the initial width based on content
		setTimeout(() => {
			const initialWidth = this.el.nativeElement.scrollWidth;
			const thContent = this.el.nativeElement.innerText || this.el.nativeElement.innerHTML;
			if (thContent == 'ID' || thContent == 'S. No' || thContent == 'Age') {
				this.renderer.setStyle(this.el.nativeElement, 'width', `${120}px`);
			} else if (thContent == 'Advisor Ready Leads') {
				this.renderer.setStyle(this.el.nativeElement, 'width', `${1300}px`);
			} else if (thContent == 'Activities' || thContent == 'Beneficiaries' || thContent == 'Role' || thContent == 'Clients' || thContent == 'Initiatives' || thContent == 'Sales Team') {
				this.renderer.setStyle(this.el.nativeElement, 'width', `${150}px`);
			} else if (thContent == 'Activities') {
				this.renderer.setStyle(this.el.nativeElement, 'width', `${270}px`);
			} else if (thContent == 'Actions'|| thContent == 'Status' || thContent == 'Campaigns' || thContent == 'Response' || thContent == 'Type' || thContent == 'Scheduled Date' || thContent == 'Actual Date' || thContent == 'Stage' || thContent == 'Importance' || thContent == 'Business Area' || thContent == 'User Type') {
				this.renderer.setStyle(this.el.nativeElement, 'width', `${180}px`);
			} else if (thContent == 'Description' || thContent == 'Trigger Condition' || thContent == 'Subject' || thContent == 'Trigger Description') {
				this.renderer.setStyle(this.el.nativeElement, 'width', `${initialWidth + 600}px`);
			} else if (thContent == 'Name' || thContent == 'Trigger Name') {
				this.renderer.setStyle(this.el.nativeElement, 'width', `${initialWidth + 250}px`);
			} else if (initialWidth > 300) {
				this.renderer.setStyle(this.el.nativeElement, 'width', `${initialWidth + 60}px`);
			} else if (thContent == 'AI Rank' || thContent == 'Trend in Prior Experience (Avg Tenure)' || thContent == 'Tenure-based Switch (Age)' || thContent == 'Opportunity at Branch') {
				this.renderer.setStyle(this.el.nativeElement, 'width', `${200}px`);
			} else if (thContent.toLowerCase().includes("market conditions")) {
				this.renderer.setStyle(this.el.nativeElement, 'width', `${200}px`);
			} else if (thContent == 'Comments') {
				this.renderer.setStyle(this.el.nativeElement, 'width', `${600}px`);
			} else {
				this.renderer.setStyle(this.el.nativeElement, 'width', `${initialWidth + 100}px`);
			}
		}, 200);
	}

	@HostListener('mousedown', ['$event']) onMouseDown(event: MouseEvent) {
		const initialWidth = this.el.nativeElement.offsetWidth;
		const startX = event.clientX;

		const mouseMoveSub = this.renderer.listen('document', 'mousemove', (e) => this.onMouseMove(e, startX, initialWidth));
		const mouseUpSub = this.renderer.listen('document', 'mouseup', () => {
			mouseMoveSub(); // Unsubscribe from mousemove on mouseup
			mouseUpSub();   // Unsubscribe from mouseup
		});
	}

	onMouseMove(event: MouseEvent, startX: number, initialWidth: number) {
		const width = initialWidth + (event.clientX - startX);
		this.renderer.setStyle(this.el.nativeElement, 'width', `${width}px`);
	}
}
